/**
 * 로그인 없이 열리는 체험 과제 데이터.
 *
 * 홍보용이다. 랜딩·프로모션에서 링크 하나로 **실제 학생 화면 그대로** 눌러보게
 * 한다. 세션을 URL 에 실어 돌리면 그 계정의 열쇠가 되어 받은 사람마다 같은 학생
 * 기록에 겹쳐 쓰므로(`demoDirectTranslation.js` 의 같은 원칙), 서버를 부르지 않고
 * 여기 심어 둔 값으로만 그린다. 여럿이 동시에 들어와도 각자의 브라우저 안에서만
 * 돌고 아무것도 남지 않는다.
 *
 * `demoData/*.json` 은 실제로 출제된 체험 과제의 섹션을 그대로 뜬 것이다
 * (question 만 뜨고 answer 는 남의 기록이라 버린다). 지인에듀에서 체험 문제지를
 * 고치면 다시 떠서 갈아끼운다. 큰 JSON 이라 본 번들에 넣지 않고 키를 열 때만
 * 내려받는다(dynamic import).
 */

const DEMO_LOADER_MAP = {
  "analysis-3206": () => import("./demoData/analysis-3206.json"),
  "analysis-penguin": () => import("./demoData/analysis-penguin.json"),
  "comprehensive-penguin": () => import("./demoData/comprehensive-penguin.json"),
  "mock-penguin": () => import("./demoData/mock-penguin.json"),
  "vocabulary-penguin": () => import("./demoData/vocabulary-penguin.json"),
  "sentence-penguin": () => import("./demoData/sentence-penguin.json"),
  "grammar-penguin": () => import("./demoData/grammar-penguin.json"),
};

/** 아는 키면 체험 데이터를 내려받아 돌려주고, 모르는 키면 null 을 돌려준다. */
export const loadDemoContent = (demoKey) => {
  const loader = DEMO_LOADER_MAP[demoKey];
  if (!loader) return Promise.resolve(null);
  return loader().then((module) => module.default || module);
};
